/* 🤖 this file was generated by svg-to-ts*/
export const icoMoonFilled: {
  name: 'moon-filled';
  data: string;
} = {
  name: 'moon-filled',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.929 4.929c-3.905 3.905-3.905 10.237 0 14.142 3.905 3.905 10.237 3.905 14.142 0 1.271-1.271 2.449-3.21 2.892-4.803.249-.893-.746-1.614-1.517-1.1-2.903 1.932-6.893 1.799-9.153-.46-2.26-2.26-2.393-6.252-.46-9.154.513-.771-.208-1.766-1.101-1.517-1.594.443-3.531 1.62-4.803 2.892z" fill="#909090"/></svg>`
};
